<!-- Hero section -->
<div class="section-fullscreen bg-image bg-overlay parallax" style="background-image: url('assets/images/slides/slide-4.jpg')">
    <div class="bg-dark-06">
        <div class="container text-center z-index-1">
            <div class="position-middle">
                <h3 class="fw-thin display-5">One Page Angular Template</h3>
                <h1 class="display-1 fw-bold color-primary">Helifax</h1>
                <h4 class="fw-thin display-4">a Perfect Theme.</h4>
                <a class="button button-md button-rounded button-spring-red" routerLink="/home-one">Buy Template</a>
            </div>
            <!-- smoothscroll button -->
            <div class="position-bottom">
                <a class="button-circle button-circle-lg button-circle-white-2 icon-lg" (click)="scrollToSection('demos')">
                    <i class="bi bi-arrow-down"></i>
                </a>
            </div>
        </div><!-- end container -->
    </div>
</div>
<!-- end Hero section -->

<!-- Demos section -->
<div class="section" id="demos">
    <div class="container">
        <div class="row g-4">
            <div *ngFor="let chooser of chooserTemplate" class="col-12 col-sm-4">
                <div class="demo-img">
                    <a [routerLink]="chooser.url">
                        <img class="img-responsive img-1" src="assets/images/demos-imgs/{{chooser.img}}" alt="img-demo"></a>
                    <div class="demo-title">
                        <a [routerLink]="chooser.url">{{chooser.text}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- end Demos section -->

<!-- Features section -->
<div class="section-md">
    <div class="container text-center">
        <div class="row">
            <div class="col-sm-6 offset-sm-3">
                <h2 class="color-primary">Template Features</h2>
            </div>
        </div>
        <div class="row g-4 g-lg-5 icon-xl mt-4">
            <div class="col-12 col-lg-4" *ngFor="let service of serviceItems">
                <div class="circle-box-xl bg-color-spring-red mb-3">
                    <i class="bi color-white" [ngClass]="service.icon"></i>
                </div>
                <h4 class="fw-normal">{{ service.title }}</h4>
            </div>
        </div>
        <!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Features section -->